type ApiMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

interface ApiRequestOptions<T> {
  method?: ApiMethod;
  path: string;
  data?: T;
}

export async function apiRequest<T = any, R = any>({
  method = 'POST',
  path,
  data,
}: ApiRequestOptions<T>): Promise<R> {
  const API_URL = import.meta.env.VITE_API_URL || 'https://qrxj6imty5.execute-api.us-east-1.amazonaws.com';

  // Validate inputs
  if (!API_URL) throw new Error('API_URL is undefined');
  if (!path) throw new Error('path is required');

  const validatedPath = path.startsWith('/') ? path : `/${path}`;
  const url = `${API_URL}${validatedPath}`;

  console.debug('API Request:', { method, url, data: data ? '[REDACTED]' : null });

  try {
    const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: method !== 'GET' ? JSON.stringify(data) : undefined,
    });

    if (!response.ok) {
      const errorBody = await response.text();
      console.error(`API Error [${method} ${url}]:`, {
        status: response.status,
        statusText: response.statusText,
        errorBody,
      });
      throw new Error(errorBody || `Request failed with status ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('Network error:', error);
    throw new Error(error instanceof Error ? error.message : 'Network request failed');
  }
}
